module.exports = __webpack_public_path__ + "img/logo1@3x.44b35740.png";